import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
} from "@reduxjs/toolkit";
import {
  createImage,
  deleteImage,
  getImages,
} from "data/server_apis/adsService";

const adsImageAdapter = createEntityAdapter({
  selectId: (ads) => ads.id,
});

export const getImagesThunk = createAsyncThunk(
  "ads/getImages",
  async (_, { rejectWithValue }) => {
    try {
      return (await getImages()).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const createImageThunk = createAsyncThunk(
  "ads/createImage",
  async (data, { rejectWithValue }) => {
    try {
      return (await createImage(data)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

export const deleteImageThunk = createAsyncThunk(
  "ads/deleteImage",
  async (id, { rejectWithValue }) => {
    try {
      return (await deleteImage(id)).data;
    } catch (err) {
      console.log(err);
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      return rejectWithValue(customError);
    }
  }
);

const AdsImageSlice = createSlice({
  name: "ads_videos",
  initialState: adsImageAdapter.getInitialState({
    loading: {},
    error: {},
    errorMessage: {},
    success: {},
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createImageThunk.pending, (state, action) => {
        state.loading = { create: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(createImageThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { create: true };
        state.success = {};
        state.errorMessage = { create: action.payload?.message };
      })
      .addCase(createImageThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { create: true };
        state.errorMessage = {};
        adsImageAdapter.addOne(state, action.payload);
      });

    builder
      .addCase(getImagesThunk.pending, (state, action) => {
        state.loading = { list: true };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(getImagesThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { list: true };
        state.success = {};
        state.errorMessage = { list: action.payload?.message };
      })
      .addCase(getImagesThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { list: true };
        state.errorMessage = {};
        adsImageAdapter.setAll(state, action.payload);
      });

    builder
      .addCase(deleteImageThunk.pending, (state, action) => {
        state.loading = { delete: action.meta.arg };
        state.error = {};
        state.success = {};
        state.errorMessage = {};
      })
      .addCase(deleteImageThunk.rejected, (state, action) => {
        state.loading = {};
        state.error = { delete: true };
        state.success = {};
        state.errorMessage = { delete: action.payload?.message };
      })
      .addCase(deleteImageThunk.fulfilled, (state, action) => {
        state.loading = {};
        state.error = {};
        state.success = { delete: true };
        state.errorMessage = {};
        adsImageAdapter.removeOne(state, action.meta.arg);
      });
  },
});

export const adsImageSelector = adsImageAdapter.getSelectors(
  (state) => state.adsImage
);

export const {} = AdsImageSlice.actions;

export default AdsImageSlice.reducer;
